import { render, staticRenderFns } from "./xghomepage.vue?vue&type=template&id=0956b918&"
import script from "./xghomepage.vue?vue&type=script&lang=js&"
export * from "./xghomepage.vue?vue&type=script&lang=js&"
import style0 from "./xghomepage.vue?vue&type=style&index=0&id=0956b918&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0956b918')) {
      api.createRecord('0956b918', component.options)
    } else {
      api.reload('0956b918', component.options)
    }
    module.hot.accept("./xghomepage.vue?vue&type=template&id=0956b918&", function () {
      api.rerender('0956b918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/xghomepage.vue"
export default component.exports